/**
 * Load project dependencies.
 */
import '@css/tokens.css';
import '@css/components.css';
import '@css/typography.css';
import '@css/tailwind.css';
import axios from 'axios';
import './analytics';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
